import { render } from "./PCRecuperarMercanciaVolcadaVistaPartida.vue?vue&type=template&id=546c8cb1&scoped=true"
import script from "./PCRecuperarMercanciaVolcadaVistaPartida.vue?vue&type=script&lang=js"
export * from "./PCRecuperarMercanciaVolcadaVistaPartida.vue?vue&type=script&lang=js"

import "./PCRecuperarMercanciaVolcadaVistaPartida.vue?vue&type=style&index=0&id=546c8cb1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546c8cb1"]])

export default __exports__